import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute = ({ user }: { user: any }) => {
    return user ? <Outlet /> : <Navigate to='/' />
}

export default PrivateRoute
